module.exports = __webpack_public_path__ + "img/rt_puk_shin2.b3e2468a.png";